import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'polylinePath'
})
export class PolylinePathPipe implements PipeTransform {
    transform(pushpin: any): { lat: number, lng: number }[] {
        if (pushpin && pushpin.snappedpoints && pushpin.snappedpoints.snappedPoints) {
            return pushpin.snappedpoints.snappedPoints.map((p: any) => ({lat: +(p.lat ?? p.latitude), lng: +(p.lng ?? p.longitude)}));
        }
        return [];
    }
}
